var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonial1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496.64 179.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{font-size:20.51px;font-family:Lato-BlackItalic, Lato;font-weight:800;font-style:italic;}.cls-3{letter-spacing:-0.02em;}.cls-4{letter-spacing:-0.03em;}.cls-5{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.91px;stroke-dasharray:10.87 10.87;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.92,52.22a38.16,38.16,0,0,1-3-8.17,35.52,35.52,0,0,1-1-8.16,36.83,36.83,0,0,1,5.46-19Q10.91,7.67,21.57,0l7.08,4.5a2.91,2.91,0,0,1,1.17,1.21,3.51,3.51,0,0,1,.41,1.62,3.47,3.47,0,0,1-.58,2q-.58.83-1.83,2.25c-.5.61-1.16,1.45-2,2.54A23.13,23.13,0,0,0,23.57,18a30.31,30.31,0,0,0-1.87,5.08,22.4,22.4,0,0,0-.8,6.08,24.37,24.37,0,0,0,.63,5.37,29.4,29.4,0,0,0,2,5.87A3.54,3.54,0,0,1,23.9,42a4,4,0,0,1-1.16,2.75,7.6,7.6,0,0,1-3.17,1.92Zm28,0a38.16,38.16,0,0,1-3-8.17,35.52,35.52,0,0,1-1-8.16,36.83,36.83,0,0,1,5.46-19Q38.89,7.67,49.55,0l7.08,4.5A2.91,2.91,0,0,1,57.8,5.71a3.51,3.51,0,0,1,.41,1.62,3.39,3.39,0,0,1-.58,2q-.59.83-1.83,2.25c-.5.61-1.15,1.45-2,2.54A23.13,23.13,0,0,0,51.55,18a30.31,30.31,0,0,0-1.87,5.08,22.4,22.4,0,0,0-.79,6.08,24.34,24.34,0,0,0,.62,5.37,29.4,29.4,0,0,0,2,5.87A3.54,3.54,0,0,1,51.88,42a3.93,3.93,0,0,1-1.16,2.75,7.53,7.53,0,0,1-3.17,1.92Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(89.34 40.14)"
  }, "&quot;Donar a Inspi", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 123.78,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 131.06,
    y: 0
  }, "a Cambio me permite ser "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22.98
  }, "parte del cambio que quie"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 222.7,
    y: 22.98
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 229.98,
    y: 22.98
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 244.54,
    y: 22.98
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 254.72,
    y: 22.98
  }, "er en M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 319.24,
    y: 22.98
  }, "\xE9"), /*#__PURE__*/React.createElement("tspan", {
    x: 328.55,
    y: 22.98
  }, "xico.&quot;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 91.9
  }, "Ana Mart\xEDnez"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 114.88
  }, "Donado"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 68.64,
    y: 114.88
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.92,
    y: 114.88
  }, "a mensual desde 2020")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 68.67,
    y: 5.74,
    width: 427.52,
    height: 173.55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonial1);
export default __webpack_public_path__ + "static/media/testimonial1.03e4d5435e5c5b46fd7de35aec277572.svg";
export { ForwardRef as ReactComponent };